import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useParams } from "react-router-dom";

import "../../../assets/css/profile.page.css";
import "../../../assets/css/utility/map.css";
import "../../../assets/css/utility/input-field.css";
import "../../../assets/css/utility/modal.css";
import "../../../assets/css/create-load-post.css";
import "../../../assets/css/load-post-details-page.css";
import "../../../assets/css/utility/progress-bar.css";
import "../../../assets/css/order-details-page.css";

import useHttp from "../../../hooks/useHttp";
import {
  SINGLE_ORDER_GET_URL,
  SINGLE_ORDER_DISPUTES_GET_URL,
  GET_ORDER_REVIEW_URL,
} from "../../../utils/api-ends";

import DisputeRequest from "./components/DisputeRequest";
import ProgressBar from "./components/ProgressBar";
import LoadInfo from "./components/LoadInfo";
import RouteMap from "./components/RouteMap";
import DisputeLog from "./components/DisputeLog";
import GiveRatingAndReview from "./components/GiveRatingAndReview";
import ShowRatingAndReview from "./components/ShowRatingAndReview";

import {
  canSeeDisputButtonValue,
  canSeeDisputSectionValue,
  singleDisputObjValue,
  canSeeWithdrawButtonValue,
} from "../../../store/slices/Dispute";
import store from "../../../store";
import { deliveryImageValue } from "../../../store/slices/deliveryImage";
import {
  canSeeGiveRatingAndReviewValue,
  orderReviewFromOtherUserValue,
  orderReviewFromThisUserValue,
  otherUserGiveReviewValue,
  thisUserGiveReviewValue,
  canSeeGiveRatingAndReviewSectionValue,
} from "../../../store/slices/order";

const OrderDetailPage = () => {
  const { sendRequests: fetchOrderDetailData } = useHttp();
  const { sendRequests: fetchDisputeData } = useHttp();
  const { sendRequests: reviewData } = useHttp();
  const { orderId } = useParams();
  const [orderDetail, setOrderDetail] = useState({});
  const [disputeDetail, setDisputeDetail] = useState({});
  const disputeData = useSelector((state) => state.Dispute);
  const orderData = useSelector((state) => state.order);
  const [canCreateDispute, setCanCreateDispute] = useState(false);

  useEffect(() => {
    const response = (data) => {
      setCanCreateDispute(data.can_create_dispute);
      store.dispatch(
        canSeeDisputSectionValue({
          canSeeDisputSection:
            data.status !== 5 && data.status !== 6 ? true : false,
        })
      );

      store.dispatch(
        canSeeGiveRatingAndReviewSectionValue({
          canSeeGiveRatingAndReviewSection: data.status === 5 ? true : false,
        })
      );

      store.dispatch(
        canSeeDisputButtonValue({
          canSeeDisputButton: data.can_create_dispute === true ? true : false,
        })
      );

      store.dispatch(
        deliveryImageValue({
          deliveryImage: data.image,
        })
      );

      setOrderDetail(data);
    };
    fetchOrderDetailData(
      {
        url: SINGLE_ORDER_GET_URL(orderId),
        method: "GET",
      },
      response
    );
  }, [orderId, fetchOrderDetailData]);

  useEffect(() => {
    const response = (data) => {
      store.dispatch(
        canSeeGiveRatingAndReviewValue({
          canSeeGiveRatingAndReview:
            data.review_from_this_user.length === 0 ? true : false,
        })
      );
      store.dispatch(
        orderReviewFromOtherUserValue({
          orderReviewFromOtherUser: data.review_from_other_user,
        })
      );
      store.dispatch(
        orderReviewFromThisUserValue({
          orderReviewFromThisUser: data.review_from_this_user,
        })
      );

      store.dispatch(
        otherUserGiveReviewValue({
          otherUserGiveReview:
            data.review_from_other_user.length !== 0 ? true : false,
        })
      );
      store.dispatch(
        thisUserGiveReviewValue({
          thisUserGiveReview:
            data.review_from_this_user.length !== 0 ? true : false,
        })
      );
    };
    reviewData(
      {
        url: GET_ORDER_REVIEW_URL(orderId),
        method: "GET",
      },
      response
    );
  }, [orderId]);

  useEffect(() => {
    const response = (data) => {
      store.dispatch(
        canSeeWithdrawButtonValue({
          canSeeWithdrawButton:
            data.can_withdraw_dispute === true ? true : false,
        })
      );

      setDisputeDetail(data);
      store.dispatch(
        singleDisputObjValue({
          singleDisputObj: data,
        })
      );
    };
    fetchDisputeData(
      {
        url: SINGLE_ORDER_DISPUTES_GET_URL(orderId),
        method: "GET",
      },
      response
    );
  }, [orderId, fetchDisputeData]);

  return (
    <>
      <ProgressBar orderDetail={orderDetail} />

      {orderData.otherUserGiveReview === true ||
        (orderData.thisUserGiveReview === true && (
          <ShowRatingAndReview
            orderReviewFromOtherUserValue={orderData.orderReviewFromOtherUser}
            orderReviewFromThisUserValue={orderData.orderReviewFromThisUser}
          />
        ))}

      {orderData.canSeeGiveRatingAndReview === true &&
        orderData.canSeeGiveRatingAndReviewSection === true && (
          <GiveRatingAndReview />
        )}

      <LoadInfo orderDetail={orderDetail} />
      <RouteMap orderDetail={orderDetail} />
      {disputeData.canSeeDisputSection === true && (
        <DisputeRequest
          disputeDetail={disputeDetail}
          canCreateDispute={canCreateDispute}
        />
      )}
      <DisputeLog disputeDetail={disputeDetail} />
    </>
  );
};

export default OrderDetailPage;
